import {XauditModel} from '../xaudit.model';

export class PredefinedNoteDataModel extends XauditModel {
  public PredefinedNoteId: string;
  public NoteSetId: string;
  public NoteOrder: number;
  public NoteDescription: string;
  public NoteTemplate: string;
  public isSeparator: boolean;
}
